import { render, staticRenderFns } from "./downGuide.vue?vue&type=template&id=4d4c74d7&scoped=true"
import script from "./downGuide.vue?vue&type=script&lang=js"
export * from "./downGuide.vue?vue&type=script&lang=js"
import style0 from "./downGuide.vue?vue&type=style&index=0&id=4d4c74d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c74d7",
  null
  
)

export default component.exports